import { Injectable } from '@angular/core';

export interface ResetPasswordLinkState {
  userId: number;
  userEmail: string;
  resetToken: string;
}

/**
 * Service for storing, retrieving, and clearing reset password link state during the password reset flow.
 * @service
 * @providedIn root
 * @example
 *   const state = { token: 'abc123', email: 'user@example.com' };
 *   resetPasswordLinkStateService.setState(state);
 *   const currentState = resetPasswordLinkStateService.getState();
 *   resetPasswordLinkStateService.clearState();
 * @method setState(state: ResetPasswordLinkState): void - Stores the provided reset password link state in memory.
 * @method getState(): ResetPasswordLinkState | null - Returns the currently stored reset password link state, or null if none exists.
 * @method clearState(): void - Clears the stored reset password link state from memory.
 */
@Injectable({
  providedIn: 'root'
})
export class ResetPasswordLinkStateService {
  private state: ResetPasswordLinkState | null = null;

  setState(state: ResetPasswordLinkState): void {
    this.state = state;
  }

  getState(): ResetPasswordLinkState | null {
    return this.state;
  }

  clearState(): void {
    this.state = null;
  }
}